import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  padding = "10px 24px 0 24px",
  marginTop = 16,
}) => {
  // if (totalPages <= 1) return null;
  return (
    <div className="paginationRow" style={{ marginTop, padding }}>
      <button
        className="paginationBtn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft size={18} />
      </button>
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i + 1}
          className={
            currentPage === i + 1
              ? `paginationBtn paginationBtnActive`
              : "paginationBtn"
          }
          onClick={() => onPageChange(i + 1)}
        >
          {i + 1 < 10 ? `0${i + 1}` : i + 1}
        </button>
      ))}
      <button
        className="paginationBtn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight size={18} />
      </button>
    </div>
  );
};

export default Pagination;
